import { ErrorPage } from "@/components/ui/error-page";
import type { AIError } from "@/types/errors";

export default function ServerError() {
  const serverError: AIError = {
    type: "ai_error",
    error: "An unexpected server error occurred",
    timestamp: new Date().toISOString()
  };

  return (
    <ErrorPage
      code="500"
      title="Internal Server Error"
      subtitle="Something went wrong on our servers. We're working on fixing it!"
      error={serverError}
    />
  );
}